import React from 'react';
import { createBulkAuction } from '../../../../../../models/auctions';
import { getAllMasks, getMask } from '../../../../../../models/masks';
import { getAllGroups, getGroup } from '../../../../../../models/groups';
import swal from 'sweetalert';
import i18n from '../../../../../../i18n';
import { Plus, Trash2 } from 'lucide-react';

export class CreateAuctionNumbers extends React.Component {
  constructor() {
    super();
    this.state = {
      input: {
        is_extra_time: false,
        is_featured: true,
        is_zakath: false,
      },
      row: [
        {
          phone_number: '',
          class: '',
          start_amount: '',
          bid_increment: '',
          start_date: '',
          end_date: '',
        },
      ],
      tempArray: {},
      errors: {},
      masks: {},
      groups: {},
      enquiries: [{ label: '', value: '' }],
      jsonLabel: '',
      jsonValue: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleRowChange = this.handleRowChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.appendData = this.appendData.bind(this);
    this.removeEnquiryData = this.removeEnquiryData.bind(this);
    this.setEnquiryJson = this.setEnquiryJson.bind(this);
    this.toggleChange = this.toggleChange.bind(this);
    this.toggleZakath = this.toggleZakath.bind(this);
    this.toggleFeatured = this.toggleFeatured.bind(this);
  }

  componentDidMount() {
    let input = this.state.input;
    input.category = this.props.category;
    input.organization = this.props.organization;
    this.setState({ input });
    this.loadAllMasks();
    this.loadAllGroups();
  }

  async loadAllMasks() {
    const response = await getAllMasks();
    let masks = response.data;
    this.setState({ masks });
  }

  async loadAllGroups() {
    const response = await getAllGroups();
    let groups = response.data;
    this.setState({ groups });
  }

  async loadMask(selected_mask) {
    const response = await getMask(selected_mask);
    let result = response.data;
    let arr = this.state.row;
    for (let i = 0; i < arr.length; i++) {
      arr[i]['class'] = result.class;
      arr[i]['start_amount'] = result.start_amount;
      arr[i]['bid_increment'] = result.bid_increment;
    }
    let tempArray = this.state.tempArray;
    tempArray['class'] = result.class;
    tempArray['start_amount'] = result.start_amount;
    tempArray['bid_increment'] = result.bid_increment;
    this.setState({ row: arr });
  }

  async loadGroup(selected_group) {
    const response = await getGroup(selected_group);
    let result = response.data;
    let arr = this.state.row;
    for (let i = 0; i < arr.length; i++) {
      arr[i]['start_date'] = result.start_date;
      arr[i]['end_date'] = result.end_date;
      arr[i]['description'] = result.description;
      arr[i]['terms'] = result.terms;
      arr[i]['terms_arabic'] = result.terms_arabic;
      arr[i]['enquiry'] = result.enquiry;
    }
    let tempArray = this.state.tempArray;
    tempArray['start_date'] = result.start_date;
    tempArray['end_date'] = result.end_date;
    tempArray['description'] = result.description;
    tempArray['terms'] = result.terms;
    tempArray['terms_arabic'] = result.terms_arabic;
    tempArray['enquiry'] = result.enquiry;
    this.setState({ row: arr, tempArray });
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
    if (event.target.name === 'mask') {
      this.loadMask(event.target.value);
    }
    if (event.target.name === 'group') {
      this.loadGroup(event.target.value);
    }
  }

  handleRowChange(event, i) {
    let row = this.state.row;
    row[i][event.target.name] = event.target.value;
    this.setState({ row });
  }

  toggleChange = () => {
    let input = this.state.input;
    input.is_extra_time = !this.state.input.is_extra_time;
    this.setState({ input });
  };

  toggleZakath = () => {
    let input = this.state.input;
    input.is_zakath = !this.state.input.is_zakath;
    this.setState({ input });
  };

  toggleFeatured = () => {
    let input = this.state.input;
    input.is_featured = !this.state.input.is_featured;
    this.setState({ input });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    try {
      let payload = this.state.input;
      payload.rows = this.state.row;
      payload.enquiries = this.state.enquiries;
      const response = await createBulkAuction(payload);
      if (response && response.data && response.data.success) {
        swal(i18n.t('success'), response.message, 'success', {
          buttons: false,
          timer: 2000,
        })
          .then((value) => {
            window.location.href = '';
          })
          .catch((response) => {
            swal('Failed', response.message, 'error');
          });
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += '\n' + element;
          }
        }
        swal('Failed', error_message, 'error');
      }
    } catch (err) {
      console.log(err);
    }
  };

  appendData(e) {
    e.preventDefault();
    let row = this.state.row;
    let tempArray = this.state.tempArray;
    row.push({
      phone_number: tempArray.phone_number,
      class: tempArray.class,
      start_amount: tempArray.start_amount,
      bid_increment: tempArray.bid_increment,
      start_date: tempArray.start_date,
      end_date: tempArray.end_date,
      description: tempArray.description,
      terms: tempArray.terms,
      terms_arabic: tempArray.terms_arabic,
      enquiry: tempArray.enquiry,
    });
    this.setState({ row });
  }

  removeEnquiryData(key) {
    let enquiries = this.state.enquiries;
    delete enquiries[key];
    this.setState({ enquiries: enquiries });
  }

  setEnquiryJson(key, event, arrKey) {
    let enquiries = this.state.enquiries;
    enquiries[arrKey][key] = event.target.value;
    this.setState({ enquiries: enquiries });
  }

  render() {
    let masks = this.state.masks;
    let groups = this.state.groups;
    let rows = this.state.row;
    return (
      <form id="UpdateProfile" autoComplete="off" onSubmit={this.handleSubmit}>
        <div className="form-content">
          {/* ========== LEFT COLUMN ========== */}
          <div className="left-column">

            {/* Group & Mask */}
            <div className="form-section">
              <h2>{i18n.t('group')} & Mask</h2>
              <div className="form-row">
                <div className="form-field">
                  <label>{i18n.t('group')}</label>
                  <select
                    name="group"
                    value={this.state.input.group}
                    onChange={this.handleChange}
                  >
                    <option value="">--{i18n.t('group')}--</option>
                    {groups.length > 0 &&
                      groups.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.group_name}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="form-field">
                  <label>{i18n.t('mask_name')}</label>
                  <select
                    name="mask"
                    value={this.state.input.selected_mask}
                    onChange={this.handleChange}
                  >
                    <option value="">--{i18n.t('mask_name')}--</option>
                    {masks.length > 0 &&
                      masks.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.mask_name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Number Entries */}
            <div className="form-section">
              <div className="section-header">
                <h2>{i18n.t('number')} Entries</h2>
                <button
                  className="button1 button1-secondary"
                  onClick={this.appendData}
                  type="button"
                >
                  <Plus size={18} /> {i18n.t('add_new')}
                </button>
              </div>

              {rows.length > 0 &&
                rows.map((item, i) => (
                  <div key={i} className="enquiry-item">
                    <p style={{ fontWeight: 600, marginBottom: '0.5rem', fontSize: '0.875rem' }}>
                      {i18n.t('number')} #{i + 1}
                    </p>
                    <div className="form-row">
                      <div className="form-field">
                        <label>{i18n.t('number')} *</label>
                        <input
                          type="text"
                          required={true}
                          name="phone_number"
                          placeholder={i18n.t('number') + ' ' + (i + 1)}
                          value={this.state.row[i].phone_number}
                          onChange={(event) => this.handleRowChange(event, i)}
                        />
                      </div>
                      <div className="form-field">
                        <label>{i18n.t('package')}</label>
                        <select
                          name="class"
                          value={this.state.row[i].class}
                          onChange={(event) => this.handleRowChange(event, i)}
                        >
                          <option value="">--{i18n.t('package')}--</option>
                          <option value="D">{i18n.t('diamond')}</option>
                          <option value="G">{i18n.t('gold')}</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label>{i18n.t('price')}</label>
                        <input
                          type="text"
                          name="start_amount"
                          placeholder="Price"
                          value={this.state.row[i].start_amount}
                          onChange={(event) => this.handleRowChange(event, i)}
                        />
                      </div>
                      <div className="form-field">
                        <label>{i18n.t('incr_amount')}</label>
                        <input
                          type="text"
                          name="bid_increment"
                          placeholder="Increment Amount"
                          value={this.state.row[i].bid_increment}
                          onChange={(event) => this.handleRowChange(event, i)}
                        />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label>
                          {i18n.t('start_date')}{' '}
                          {this.state.row[i].start_date ? '(' + this.state.row[i].start_date + ')' : ''}
                        </label>
                        <input
                          type="datetime-local"
                          name="start_date"
                          value={this.state.row[i].start_date}
                          onChange={(event) => this.handleRowChange(event, i)}
                        />
                      </div>
                      <div className="form-field">
                        <label>
                          {i18n.t('end_date')}{' '}
                          {this.state.row[i].end_date ? '(' + this.state.row[i].end_date + ')' : ''}
                        </label>
                        <input
                          type="datetime-local"
                          name="end_date"
                          value={this.state.row[i].end_date}
                          onChange={(event) => this.handleRowChange(event, i)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>

          {/* ========== RIGHT COLUMN ========== */}
          <div className="right-column">
            <div className="form-section">
              <h2>Configuration</h2>

              <div className="toggle-field">
                <label>{i18n.t('extra_time')}</label>
                <div
                  className={`toggle ${this.state.input.is_extra_time ? 'active' : ''}`}
                  onClick={this.toggleChange}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>
              {this.state.input.is_extra_time && (
                <div className="form-field" style={{ marginTop: '12px' }}>
                  <label>{i18n.t('extra_time')} ({i18n.t('in_minutes')})</label>
                  <input
                    name="extra_time"
                    type="number"
                    value={this.state.input.extra_time}
                    onChange={this.handleChange}
                    placeholder={i18n.t('in_minutes')}
                  />
                </div>
              )}

              <div className="toggle-field">
                <label>Is Featured</label>
                <div
                  className={`toggle ${this.state.input.is_featured ? 'active' : ''}`}
                  onClick={this.toggleFeatured}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>

              <div className="toggle-field">
                <label>Is Zakath</label>
                <div
                  className={`toggle ${this.state.input.is_zakath ? 'active' : ''}`}
                  onClick={this.toggleZakath}
                >
                  <div className="toggle-slider"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Submit Footer */}
        <div className="action-buttons-l2 border-top-light">
          <button
            type="button"
            className="button1 button1-gray"
            onClick={() => window.history.back()}
          >
            {i18n.t('cancel')}
          </button>
          <button type="submit" className="button1 button1-primary">
            Save Auction
          </button>
        </div>
      </form>
    );
  }
}